import React from 'react';
import { connect } from 'react-redux';
import { streamActions, userProfileSelectors } from '@lifesize/nucleus';
import { hooks } from '@lifesize/clients.sdk';
import { closeWhiteboardWebapp } from 'actions/Plugins';
import { toggleMiniPlayer } from 'actions/MiniPlayer';
import InCall from 'components/InCall/InCallView';
import { popoutPresentationSelector } from 'selectors/call';
import { isMiniPlayerOpenSelector } from 'selectors/miniPlayer';
import useIsMinimized from 'hooks/useIsMinimized';

export const eatClickTimeout = 1000;

const mapStateToProps = (state, ownProps) => {
  const isGuest = userProfileSelectors.selectIsGuest(state);
  // IMPORTANT: for the guest join flow, guests will be stuck in the InCallView during a call so the popout is located
  // there (the CoreLayout is not used for guests). For registered users, the user may leave the InCallView if they
  // return to the main app (for chat, etc), so the popout is located in the CoreLayout (so that it continues to be
  // available)
  const isGuestPopoutOpen = isGuest && popoutPresentationSelector(state);
  const isMiniPlayerOpen = isMiniPlayerOpenSelector(state);

  return {
    eatClickTimeout,
    isGuestPopoutOpen,
    isVisible: ownProps.isVisible,
    isMiniPlayerOpen
  };
};

const mapDispatchToProps = (dispatch) => ({
  endLocalStream: () => dispatch(streamActions.endLocalStream()),
  webappCloseWhiteboard: () => dispatch(closeWhiteboardWebapp()),
  toggleMiniPlayer: () => dispatch(toggleMiniPlayer())
});

const FunctionalWrapper = (props) => {
  const callConnected = hooks.useCallConnected();
  const isModerator = hooks.useIsCurrentUserModerator();
  const isMinimized = useIsMinimized();
  return <InCall {...props} isVisible={callConnected} isModerator={isModerator} isMinimized={isMinimized} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(FunctionalWrapper);
